import def from '@/images/mapbox/generic/default.svg';
import clicked from '@/images/mapbox/generic/clicked.svg';
import checked from '@/images/mapbox/generic/checked.svg';
import checked_clicked from '@/images/mapbox/generic/checked-clicked.svg';
import def_found from '@/images/mapbox/markedAsFound/def-found.svg';
import clicked_found from '@/images/mapbox/markedAsFound/clicked-found.svg';
import checked_found from '@/images/mapbox/markedAsFound/checked-found.svg';
import checked_clicked_found from '@/images/mapbox/markedAsFound/checked-clicked-found.svg';

import { MapSourceType } from './Mapbox';
import { AssetTypeEnum } from '@/types/enums';

export type ImageMap = {
  key: string;
  desc?: any;
  img: HTMLImageElement;
};

export const CLICKED_ICON = 'clicked';
export const DEFAULT_ICON = 'default';
export const CHECKED_ICON = 'checked';
export const CHECKED_CLICKED_ICON = 'checked-clicked';

export const DEFAULT_FOUND_ICON = 'def-found';
export const CLICKED_FOUND_ICON = 'clicked-found';
export const CHECKED_FOUND_ICON = 'checked-found';
export const CHECKED_CLICKED_FOUND_ICON = 'clicked-clicked-found';

export function setupCustomImages() {
  const imagesMap = new Map<MapSourceType, ImageMap[]>();

  const CLICKED_IMG = new Image();
  CLICKED_IMG.src = clicked;
  const DEFAULT_IMG = new Image();
  DEFAULT_IMG.src = def;
  const CHECKED_IMG = new Image();
  CHECKED_IMG.src = checked;
  const CHKCLCK_IMG = new Image();
  CHKCLCK_IMG.src = checked_clicked;

  const DEFAULT_FOUND_IMG = new Image();
  DEFAULT_FOUND_IMG.src = def_found;
  const CLICKED_FOUND_IMG = new Image();
  CLICKED_FOUND_IMG.src = clicked_found;
  const CHECKED_FOUND_IMG = new Image();
  CHECKED_FOUND_IMG.src = checked_found;
  const CHECKED_CLICKED_FOUND_IMG = new Image();
  CHECKED_CLICKED_FOUND_IMG.src = checked_clicked_found;

  const imgArray: ImageMap[] = [
    { key: CLICKED_ICON, img: CLICKED_IMG, desc: 'mapbox.clicked' },
    { key: DEFAULT_ICON, img: DEFAULT_IMG, desc: 'mapbox.default' },
    { key: CHECKED_ICON, img: CHECKED_IMG, desc: 'mapbox.checked' },
    {
      key: CHECKED_CLICKED_ICON,
      img: CHKCLCK_IMG,
      desc: 'mapbox.clicked_checked',
    },
    {
      key: DEFAULT_FOUND_ICON,
      img: DEFAULT_FOUND_IMG,
      desc: 'mapbox.def_found',
    },
    {
      key: CLICKED_FOUND_ICON,
      img: CLICKED_FOUND_IMG,
      desc: 'mapbox.clicked_found',
    },
    {
      key: CHECKED_FOUND_ICON,
      img: CHECKED_FOUND_IMG,
      desc: 'mapbox.checked_found',
    },
    {
      key: CHECKED_CLICKED_FOUND_ICON,
      img: CHECKED_CLICKED_FOUND_IMG,
      desc: 'mapbox.checked_clicked_found',
    },
  ];

  imagesMap.set(AssetTypeEnum.CAR, imgArray);
  imagesMap.set(AssetTypeEnum.CUSTOM, imgArray);
  return imagesMap;
}
